import { ZoomIcon } from '@ui/icons/ZoomIcon';

import { Contact, Tournament } from '@features/shared/api/typings';
import { TournamentClockControlBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentClockControlBadge';
import { TournamentEntranceBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentEntranceBadge';
import { TournamentExcelBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentExcelBadge';
import { TournamentLinkBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentLinkBadge';
import { TournamentModeBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentModeBadge';
import { TournamentOrgBadges } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentOrgBagdes';
import { TournamentParticipantsBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentParticipantsBadge';
import { TournamentRcfBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentRcfBadge';
import { TournamentRulesBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentRulesBadge';
import { TournamentSystemBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentSystemBadge';

import { TournamentPgnBadge } from './badges/TournamentPgnBadge';

type Props = {
  clubId?: string;
  tournament?: Tournament;
  isManager?: boolean;
  isAdmin?: boolean;
  isRcfReportAvailable: boolean;
  rcfReportError?: string;
  onRcfReportClick: () => void;
};

export function TournamentBadges({
  clubId,
  tournament,
  isManager,
  isAdmin,
  isRcfReportAvailable,
  rcfReportError,
  onRcfReportClick,
}: Props) {
  return (
    <>
      <TournamentClockControlBadge tournament={tournament} />
      <TournamentModeBadge tournament={tournament} />
      <TournamentEntranceBadge tournament={tournament} isManager={isManager} />
      <TournamentSystemBadge tournament={tournament} />
      <TournamentParticipantsBadge tournament={tournament} />
      <TournamentPgnBadge tournament={tournament} isManager={isManager} isAdmin={isAdmin} />
      <TournamentExcelBadge clubId={clubId} tournament={tournament} />
      <TournamentRulesBadge tournament={tournament} />
      <TournamentOrgBadges tournament={tournament} />
      {isManager && (
        <TournamentRcfBadge
          tournament={tournament}
          isReportAvailable={isRcfReportAvailable}
          error={rcfReportError}
          onClick={onRcfReportClick}
        />
      )}

      {tournament?.contacts?.map((c) => (
        <TournamentLinkBadge
          key={c.label + c.name + c.uri}
          href={c.uri}
          highlighted={isZoomContact(c)}
        >
          {isZoomContact(c) && (
            <>
              <ZoomIcon />
              &nbsp;
            </>
          )}

          {c.name}
          {c.label ? `: ${c.label}` : ''}
        </TournamentLinkBadge>
      ))}
    </>
  );
}

function isZoomContact(c: Contact) {
  return Boolean(c.name.toLowerCase().indexOf('zoom') !== -1 && c.uri);
}
